import { insert } from 'fn/lists/insert.js';

const assign = Object.assign;

export default function update(fn, array, source) {
    const id  = fn(source);
    const obj = array.find((obj) => fn(obj) === id);

    return obj ?
        assign(obj, source) :
        insert(fn, array, source) ;
}
